import { render, staticRenderFns } from "./Index-compras.vue?vue&type=template&id=83a8df1a"
import script from "./Index-compras.vue?vue&type=script&lang=js"
export * from "./Index-compras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports